import React from "react";
import { connect } from "react-redux";
import { Button, Col, Row, Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import noRecord from "./../../../assets/img/no-record.png";
import {
  CheckCircle,
  CheckCircleOutline,
  Visibility,
  SaveAlt,
  Payment,
} from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip";
import {
  getBillingPaymentDetails,
  getBillingHistoryAction,
  getInvoiceByPeriodAction,
  billingPaymentCaptureAction,
  getPaymentRecipt,
} from "../../../actions/BillingActions";
import moment from "moment";
import ReactPaginate from "react-paginate";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { currencyFormat } from "./../../Common/Common";
//import { useHistory } from "react-router-dom";
import InvoiceDetailsTable from "./../Invoices/InvoiceDetailsTable";
import * as code from "./../../../config/Constants";
import { toastMessage } from "./../../Common/Common";
import * as message from "./../../../config/CommonMessages";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { cryptoTokenDecode } from "../../Common/Common";
import UrlConstants from "../../../config/UrlConstants";
import BillingReceipt from "../BillingHistory/BillingReceipt";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
var CryptoJS = require("crypto-js");

const columns = [
  {
    name: "Month/Year",
    selector: "monthYear",
    sortable: true,
    ignoreRowClick: true,
  },
  {
    name: "Amount",
    selector: "amount",
    sortable: true,
  },
  {
    name: "Status",
    selector: "status",
    // sortable: true,
  },
  {
    name: "Payment status",
    selector: "PaymentStatus",
    sortable: true,
  },
  {
    name: "Payment Date",
    selector: "created",
    sortable: true,
  },
  {
    name: "",
    selector: "action",
    right: true,
    ignoreRowClick: true,
  },
];

function BillingPaymentDetails({
  getBillingPaymentDetails,
  getBillingHistoryAction,
  getInvoiceByPeriodAction,
  billingPaymentCaptureAction,
  getPaymentRecipt,
}) {
  //const history = useHistory();
  const today = moment();
  //console.log("today", today.format("YYYYMM"));
  // const currentMonthYear = moment().format("MMM YYYY");
  // const futureMonthYear = moment(today).add(1, "M").format("Do MMM YYYY");

  const [paymentDetails, setPaymentDetails] = React.useState({});
  const [billingHistory, setBillingHistory] = React.useState([]);
  const [invoiceDetails, setInvoiceDetails] = React.useState({});

  const [invoicePrompt, setInvoicePrompt] = React.useState(false);

  const [showLoader, setShowLoader] = React.useState(false);
  const [numberOfPages, setnumberOfPages] = React.useState();
  const [PageNumber, setPageNumber] = React.useState(0);
  const [Rerander, setRerander] = React.useState(0);
  const [PageSize, SetPageSize] = React.useState(10);
  const [captureinvoiceperiod, Setcaptureinvoiceperiod] = React.useState("");
  const didMount = React.useRef(false);
  const [ownerId, setOwnerId] = React.useState(
    localStorage.getItem("usertype") === "VENDOR"
      ? localStorage.getItem("ownerId")
      : localStorage.getItem("ID")
  );
  const [usertype, setUsertype] = React.useState(cryptoTokenDecode().usertype);
  const [permissionArray, setPermissionarray] = React.useState([]);
  const [invoicePeriod, setInvoicePeriod] = React.useState("");
  const [invoiceReceipt, setInvoiceReceipt] = React.useState(false);
  const [receipthtml, setReceipthtml] = React.useState();
  const [childComponentRander, setChildComponentRander] = React.useState(false);
  const [invoiceId, setInvoiceId] = React.useState();

  React.useEffect(() => {
    getUserPermissions();
    getPaymentDetails();
  }, []);

  React.useEffect(() => {
    if (didMount.current) {
      getBillingHistory();
    } else {
      didMount.current = true;
    }
  }, [PageNumber, Rerander]);

  function getUserPermissions() {
    if (usertype === message.VENDOR) {
      let permission = localStorage.getItem("otherInfo");
      let permissionarray;
      if (permission) {
        let bytes = CryptoJS.AES.decrypt(
          permission,
          REACT_APP_CRYPTO_SECRET_KEY
        );
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        // console.log("getUserPermissions decryptedData39", decryptedData);
        permissionarray = decryptedData.split(",");
        // console.log("getUserPermissions permissionarray", permissionarray);
        setPermissionarray(permissionarray);
      }
    }
  }

  function checkPermission(checkFor) {
    if (usertype === message.ACCTOWNER) {
      return true;
    } else {
      const hasSome =
        permissionArray &&
        permissionArray.length > 0 &&
        checkFor.some((item) => permissionArray.includes(item));
      return hasSome;
    }
  }

  function RecepitModal() {
    setInvoiceReceipt(false);
  }

  const handlePageClick = (event) => {
    setPageNumber(event.selected);
  };

  const handleChange = (event) => {
    SetPageSize(event.target.value);
    setRerander(!Rerander);
  };

  function getPaymentDetails() {
    let data = {
      userId: ownerId,
      invoicePeriod: today.format("YYYYMM"),
    };
    getBillingPaymentDetails(data)
      .then((res) => {
        // console.log("here getBillingPaymentDetails", res);
        setPaymentDetails(res.data);
        setChildComponentRander(!childComponentRander);
        setRerander(!Rerander);
      })
      .catch((err) => {
        console.log(err);
      });

    return paymentDetails;
  }

  function getPaymentReceiptfunctions(invoice) {
    let data = {
      invoiceID: invoice._id,
      invoicePeriod: invoice.invoicePeriod,
    };
    setShowLoader(true);
    getPaymentRecipt(data)
      .then((res) => {
        // console.log("186res", res);
        if (res && res.status === 200) {
          setReceipthtml(res.data);
          setShowLoader(false);
          setInvoiceReceipt(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getBillingHistory() {
    setShowLoader(true);
    let data = {
      pageSize: PageSize,
      page: PageNumber,
      userId: ownerId,
    };
    getBillingHistoryAction(data)
      .then((res) => {
        // console.log("here getBillingHistoryAction", res);
        // console.log("here no of pgs", res.data.data.total);
        setShowLoader(false);
        setBillingHistory(res.data.data);
        setnumberOfPages(res.data.total);
      })
      .catch((err) => {
        setShowLoader(false);
        setBillingHistory([]);
        console.log(err);
      });

    return billingHistory;
  }

  function getInvoiceDetails(invoicePeriod) {
    let data = {
      userId: ownerId,
      invoicePeriod: invoicePeriod,
    };
    getInvoiceByPeriodAction(data)
      .then((res) => {
        // console.log("getInvoiceDetails", res);
        let invoiceData = { ...invoiceDetails };
        invoiceData = res.data;
        setInvoiceDetails(invoiceData);
        //setRerander(!Rerander);
      })
      .catch((err) => {
        console.log(err);
      });

    return invoiceDetails;
  }

  function openInvoicePrompt(invoicePeriod, invoiceIdd) {
    // console.log("====================>invoice period==", invoicePeriod);
    // getInvoiceDetails(invoicePeriod);
    setInvoicePeriod(invoicePeriod);
    setInvoiceId(invoiceIdd);
    setInvoicePrompt(true);
  }

  function closeInvoicePrompt() {
    setInvoicePrompt(false);
  }

  function confirmPaymentCapture(invoiceperiod, invoiceidd) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="">
            <div className="react-confirm-alert-body">
              <h2>Confirmation</h2>
              <p>
                Payment will be processed after you click the 'Yes' button. Do
                you want to go on?
              </p>
              <div className="react-confirm-alert-button-group">
                <button
                  onClick={() => {
                    billingPaymentCapture(invoiceperiod, invoiceidd);
                    onClose();
                  }}
                >
                  {" "}
                  Yes{" "}
                </button>
                <button onClick={onClose}>No</button>
              </div>
            </div>
          </div>
        );
      },
    });
    // billingPaymentCapture(invoiceperiod);
  }

  function billingPaymentCapture(invoiceperod, invoiceidd) {
    // console.log("===invoice period 215===", captureinvoiceperiod);
    setShowLoader(true);
    let data = {
      userid: ownerId,
      invoicePeriod: invoiceperod,
      invoiceid: invoiceidd,
    };
    billingPaymentCaptureAction(data)
      .then((res) => {
        // console.log("billingPaymentCaptureAction", res);
        setShowLoader(false);
        if (res.status === code.OK) {
          toastMessage(code.SUCCESS, res.data.data);
          setRerander(!Rerander);
        } else {
          toastMessage(code.ERROR, res.data);
          setRerander(!Rerander);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        console.log(err);
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
      });
  }
  // function calculateBillableCount(freeCount,totalCount){
  //   if(freeCount > 0){
  //     if(totalCount > 0){
  //       if(totalCount > freeCount){
  //         return totalCount - freeCount;
  //       }
  //       else{
  //         return 0;
  //       }
  //     }
  //     else{
  //       return totalCount;
  //     }
  //   }
  //   else{
  //     return totalCount;
  //   }
  // }

  let rows = [];

  for (var i = 0, len = billingHistory.length; i < len; i++) {
    let invoice = billingHistory[i];
    let data = {
      // monthYear: moment(invoice.invoiceDate).format("MMM YYYY"),
      monthYear: moment(String(invoice.invoicePeriod)).format("MMM YYYY"),
      amount: currencyFormat(invoice.finalAmount),
      status:
        invoice.invoicePaid && invoice.invoiceStatus === "SUCCESS" ? (
          <Tooltip title="PAID">
            <CheckCircle className="check" style={{ color: "green" }} />
          </Tooltip>
        ) : invoice.invoiceStatus === "FAILURE" ? (
          <Tooltip title="FAILURE">
            <CheckCircle className="check" style={{ color: "red" }} />
          </Tooltip>
        ) : invoice.invoiceStatus === "UNPAID" ? (
          <Tooltip title="UNPAID">
            <CheckCircleOutline className="check-out" />
          </Tooltip>
        ) : (
          <Tooltip title="PROCESS">
            <CheckCircle className="check" style={{ color: "orange" }} />
          </Tooltip>
        ),
      PaymentStatus: invoice.invoiceStatus,
      created: invoice.invoicePaid
        ? moment(invoice.paymentDate).format("MM-DD-YYYY")
        : "-",
      action: (
        <div className="action-btns">
          <Button
            variant="transparent"
            onClick={() => {
              openInvoicePrompt(invoice.invoicePeriod, invoice._id);
            }}
          >
            <Tooltip title="View">
              <Visibility />
            </Tooltip>
          </Button>
          {invoice.invoicePaid && (
            <>
              <Button
                variant="transparent"
                // onClick={() =>
                //   (window.location.href = invoice.payment[0].invoicepdf)
                // }
                onClick={() => getPaymentReceiptfunctions(invoice)}
              >
                <Tooltip title="Download">
                  <SaveAlt />
                </Tooltip>
              </Button>
            </>
          )}
          {!invoice.invoicePaid &&
          (invoice.invoiceStatus == "FAILURE" ||
            invoice.invoiceStatus == "UNPAID") &&
          checkPermission([message.manage_billing_details]) ? (
            <Button
              variant="transparent"
              onClick={() => {
                // console.log("payment capture");
                confirmPaymentCapture(invoice.invoicePeriod, invoice._id);
              }}
            >
              <Tooltip title="Pay Now">
                <Payment />
              </Tooltip>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    };

    rows.push(data);
  }
  return (
    <>
      <div className="step-progress transaction-create">
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
          <Col xs={12} sm={3}>
            <h4 className="title-med mt-0 pt-1">Billing Payment Details</h4>
          </Col>
        </Row>
        <div
          className="admin-steps admin-content-area"
          style={{ paddingTop: 20 }}
        >
          <div className="container-custom">
            <Row>
              <Col xs={12} sm={4}>
                <h5 className="font-16 color-blue-4 font-600">Billing Info</h5>
                <div className="color-grey-1 font-14">
                  Upcoming invoice amount
                </div>
                <h4 className="font-20 color-blue-4 font-600">
                  US $
                  {paymentDetails && paymentDetails.finalAmount
                    ? paymentDetails.finalAmount.toFixed(2)
                    : 0}
                </h4>
                <Row>
                  <Col xs={12} sm={6}>
                    Invoice for month
                  </Col>
                  <Col xs={12} sm={6}>
                    {paymentDetails && paymentDetails.invoiceDate
                      ? moment(paymentDetails.invoiceDate).format("MMM YYYY")
                      : ""}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    Invoice Start Date
                  </Col>
                  <Col xs={12} sm={6}>
                    {paymentDetails && paymentDetails.invoiceStartdate
                      ? moment(paymentDetails.invoiceStartdate).format(
                          "Do MMM YYYY"
                        )
                      : ""}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    Next payment date
                  </Col>
                  <Col xs={12} sm={6}>
                    {moment()
                      .add(1, "M")
                      .startOf("month")
                      .format("Do MMM YYYY")}
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={8}>
                <h5 className="font-16 color-blue-4 font-600">
                  Invoice Details
                </h5>
                <Row>
                  <InvoiceDetailsTable
                    userId={ownerId}
                    invoicePeriod={today.format("YYYYMM")}
                    childComponentRander={childComponentRander}
                    isCurrentInvoice={true}
                  />
                </Row>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col className="col-auto">
                <h4 className="title-med mt-0 pt-1">Billing History</h4>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                {showLoader ? (
                  <div className="page-loader fixed">
                    <div className="page-loader-inner">
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                ) : rows.length === 0 ? (
                  <>
                    <div className="no-transaction no-record no-datatable">
                      <div className="no-transaction-inner">
                        <img src={noRecord} alt="no record" />
                        <p>No record found</p>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div align="right" className="auto-flex">
                      <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
                        <InputLabel id="demo-select-small">Limit</InputLabel>
                        <Select
                          labelId="demo-select-small"
                          id="demo-select-small"
                          value={PageSize}
                          label="Page"
                          onChange={handleChange}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={50}>50</MenuItem>
                          <MenuItem value={100}>100</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <DataTable
                      title="Billing History"
                      columns={columns}
                      data={rows}
                      persistTableHead
                      style={{ marginBottom: 10 }}
                    />
                  </>
                )}

                {rows.length > 0 && (
                  <div className="auto-margin">
                    <ReactPaginate
                      previousLabel={"previous"}
                      nextLabel={"next"}
                      breakLabel={"..."}
                      pageCount={numberOfPages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Invoice Details Modal */}
      {invoicePrompt && (
        <Modal
          show={invoicePrompt}
          onHide={() => closeInvoicePrompt()}
          aria-labelledby="example-custom-modal-styling-title"
          backdrop={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Invoice Details
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <InvoiceDetailsTable
              userId={ownerId}
              invoicePeriod={invoicePeriod}
              isCurrentInvoice={false}
              invoiceId={invoiceId}
            />
          </Modal.Body>
        </Modal>
      )}

      {/* receipt modal */}
      <Modal
        show={invoiceReceipt}
        onHide={() => RecepitModal()}
        aria-labelledby="example-custom-modal-styling-title"
        backdrop={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            DOTWORK
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="pb-0">
          <BillingReceipt receipthtml={receipthtml} />
        </Modal.Body>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getBillingPaymentDetails,
    getBillingHistoryAction,
    getInvoiceByPeriodAction,
    billingPaymentCaptureAction,
    getPaymentRecipt,
  }
)(BillingPaymentDetails);
